export default __webpack_public_path__ + "static/media/Suivi-1.1c961e78.gif";